import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { mergeQuery, replaceQuery } from 'utils/queries';

export interface QueryType {
  [key: string]: string | number | boolean | number[] | null | undefined;
}

export const useAppNavigate = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const update = useCallback(
    (queries: QueryType) => {
      navigate(`${pathname}${mergeQuery(search, queries)}`);
    },
    [navigate, search]
  );

  const persist = useCallback(
    (to: string) => {
      navigate(`${to}${search}`);
    },
    [navigate, search]
  );

  const merge = useCallback(
    (to: string, queries: QueryType) => {
      navigate(`${to}${mergeQuery(search, queries)}`);
    },
    [navigate, search]
  );

  const replace = useCallback(
    (to: string, queries: QueryType) => {
      navigate(`${to}${replaceQuery(queries)}`);
    },
    [navigate]
  );

  const clear = useCallback(
    (to: string) => {
      navigate(to);
    },
    [navigate]
  );

  return { persist, merge, replace, update, clear };
};
